import React from 'react'
import styled, { keyframes } from 'styled-components'

import Logo from './ic-brand-color.svg'

const Simulating = () => (
  <Wrapper>
    <Spinner src={Logo} />
    <Text>Estamos a avaliar o melhor tarifário para si</Text>
  </Wrapper>
)

const Scale = keyframes`
  0% {
    transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
    animation-timing-function: ease-out;
  }
  40% {
    transform: perspective(400px) translate3d(0, 0, 80px) rotate3d(0, 1, 0, -190deg);
    animation-timing-function: ease-out;
  }
  50% {
    transform: perspective(400px) translate3d(0, 0, 80px) rotate3d(0, 1, 0, -170deg);
    animation-timing-function: ease-in;
  }
  80% {
    transform: perspective(400px) scale3d(.95, .95, .95);
    animation-timing-function: ease-in;
  }
  100% {
    transform: perspective(400px);
    animation-timing-function: ease-in;
  }
`

const Spinner = styled.img`
  width: 65px;
  height: 65px;
  margin-bottom: 20px;
  animation: ${Scale} 2s linear infinite;
  backface-visibility: visible;
  animation-fill-mode: both;
`

const Wrapper = styled.div`
  height: calc(100% - 60px);
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const Text = styled.div`
  display: block;
  margin: 0 auto;
  color: #CCC;
`

export default Simulating



// WEBPACK FOOTER //
// ./src/components/Simulating/index.js